<template>
    <v-container class="pa-5" fluid>
        <NettoMarkUpDialog
            :is-open="nettoMarkUpDialog"
            :netto-mark-up-data="currentNettoMarkUp"
            @on-confirm="getNettoMarkUps"
            @on-close="closeNettoMarkUpDialog"
        />
        <v-row align="center" dense>
            <v-col cols="auto">
                <page-title>Narzut netto</page-title>
            </v-col>
            <v-col cols="auto">
                <SelectMenu />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="nettoMarkUps"
                        :loading="nettoMarkUpsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="nettoMarkUpData"
                        @pagination="updatePagination"
                    >
                        <template #item.name="{item}">
                            {{ item.name }}
                        </template>
                        <template #item.type="{item}">
                            {{ item.type.name }}
                        </template>
                        <template #item.value="{item}">
                            {{ item.value }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Edytuj"
                                            v-on="on"
                                            @click="showEditNettoMarkUpDialog(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edytuj</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import SelectMenu from '@/views/Configurations/CalculationsCosts/Common/SelectMenu'
import NettoMarkUpDialog from './NettoMarkUpDialog'

import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'

import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'NettoMarkUp',
    components: {
        PageTitle,
        SelectMenu,
        NettoMarkUpDialog
    },
    mixins: [
        filters,
        pagination,
        tooltipDelay
    ],
    data() {
        return {
            currentNettoMarkUp: {},
            nettoMarkUpDialog: false,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Typ',
                    value: 'type',
                    sortable: false,
                    width: 250
                },
                {
                    text: 'Narzut %',
                    value: 'value',
                    sortable: false,
                    width: 250
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        nettoMarkUps() {
            return this.$store.state.configurations.calculationsCosts.nettoMarkUps.nettoMarkUps
        },
        nettoMarkUpsLoading() {
            return this.$store.state.configurations.calculationsCosts.nettoMarkUps.nettoMarkUpsLoading
        },
        savedFilters() {
            return this.$store.state.configurations.calculationsCosts.nettoMarkUps.filters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    mounted() {
        this.getNettoMarkUps()
    },
    methods: {
        getNettoMarkUps() {
            this.$store.dispatch('configurations/calculationsCosts/getNettoMarkUps', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showEditNettoMarkUpDialog(nettoMarkUp) {
            this.currentNettoMarkUp = nettoMarkUp
            this.nettoMarkUpDialog = true
        },
        closeNettoMarkUpDialog() {
            this.nettoMarkUpDialog = false

            setTimeout(() => {
                this.currentNettoMarkUp = {}
                this.nettoMarkUp = {}
            }, 500)
        },
        saveNettoMarkUp() {
            this.nettoMarkUpDialog = false
            this.getNettoMarkUps()
            this.closeNettoMarkUpDialog()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getNettoMarkUps()
            }
            this.clearPaginationPending()
        },
    }
}
</script>